export default __webpack_public_path__ + "static/media/CNo.57-4.7fa73b3a.jpg";